import type { TenantDivisionListItemSchema } from '@/entities/tenants-divisions/api/generated/model';
import type { SelectOption } from '@/shared/ui/form/select/helpers/types';

/**
 * 組織データを年度ごとにグルーピングする
 *
 * @returns 年度（文字列）→ その年度の組織一覧 の Map
 */
export const groupDivisionsByYear = (
  items: TenantDivisionListItemSchema[] | undefined,
): Map<string, TenantDivisionListItemSchema[]> => {
  const map = new Map<string, TenantDivisionListItemSchema[]>();
  if (!items?.length) return map;
  for (const item of items) {
    const yearKey = String(item.year);
    const bucket = map.get(yearKey);
    if (bucket) {
      bucket.push(item);
    } else {
      map.set(yearKey, [item]);
    }
  }
  return map;
};

/**
 * 組織データから利用可能な年度を昇順で返す
 */
export const getAvailableYears = (items: TenantDivisionListItemSchema[] | undefined): string[] => {
  const years = new Set<string>();
  for (const item of items ?? []) {
    years.add(String(item.year));
  }
  return [...years].sort((a, b) => Number(a) - Number(b));
};

/**
 * 指定年度の組織を Select オプションに変換する
 *
 * ラベルは `{code}:{name}` 形式（既存の Cascader 表記に合わせる）。
 */
export const getDivisionOptionsForYear = (
  divisionsByYear: Map<string, TenantDivisionListItemSchema[]>,
  year: string,
): SelectOption[] => {
  const divisions = divisionsByYear.get(year) ?? [];
  return divisions.map((d) => ({
    label: `${d.code}:${d.name}`,
    value: d.id,
  }));
};
